/* eslint-disable no-unused-vars */
import { useContext } from 'react';
import axios from 'axios';
import { Buffer } from 'buffer';

import showToast from 'src/components/toastyService';
import { LogContext } from 'src/components/LogProvider';
import { transformResponse } from 'src/services/auth';

const proxyUrl = window.globalConfig.PROXY_URL;
const apiUrl = window.globalConfig.COBRANCA_URL;

//=-----------------------------------------------------------------------------------=//

export async function GetTitulosReceberApi(porta, filtros) {
  const url = localStorage.getItem('url');
  const loginErp = localStorage.getItem('loginErp');
  const senhaErp = localStorage.getItem('senhaErp');

  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');

  if (!porta) {
    showToast('error', 'Porta Inválida');
    return;
  }

  const parametros = {
    vEmiIni: filtros.emissaoInicio,
    vEmiFim: filtros.emissaoFim,
    vVctIni: filtros.vencimentoInicio,
    vVctFim: filtros.vencimentoFim,
    vVlrIni: filtros.valorInicio,
    vVlrFim: filtros.valorFim,
    vNfvIni: filtros.abc,
    vNfvFim: filtros.abc,
  };

  const newParametros = Object.entries(parametros)
    .map(([key, value]) => `<${key}>${value}</${key}>\n `)
    .join('');

  let data = `<?xml version="1.0" encoding="utf-8"?>\n<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">\n  
    <soap:Body>\n    
     <${porta}>\n       
        <user>${loginErp}</user>\n      
        <password>${senhaErp}</password>\n        
        <encryption>0</encryption>\n     
        <parameters>\n 
            ${newParametros}
        </parameters>\n              
      </${porta}>\n  
    </soap:Body>\n
  </soap:Envelope>\n 
  `;

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${proxyUrl}/${url}`,
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    const responseData = transformResponse(response.data, 'result')[0].children;

    const msg = responseData.find((i) => i.name === 'msgRet')?.value;

    if (msg) showToast('success', msg);
    return responseData;
  } catch (error) {
    showToast('error', error);
  }
}

//=-----------------------------------------------------------------------------------=//

export async function setTitulosApi(
  porta,
  newCodEmp,
  newCodFil,
  newCodCli,
  newNumTit,
  newCodTpt,
  newVlrAbe,
  newVlrAba,
  newVctPro,
  newVctLim,
  newBolAce,
  newMsgBol,
  newNomCli,
  newTipCli,
  newCgcCpf,
  newEndCli,
  newCepCli,
  newCidCli,
  newBaiCli,
  newSigUfs,
  newFonCli,
  newTaxMul,
  newTaxJrs,
  newArqJso,
  newIdeFin,
  newSitFin,
  newUrlBol,
  newUrlPdf,
  newIdeBil,
  newIdeCon
) {
  const url = localStorage.getItem('url');
  const loginErp = localStorage.getItem('loginErp');
  const senhaErp = localStorage.getItem('senhaErp');

  if (!porta) {
    showToast('error', 'Porta Inválida');
    return;
  }

  const parametros = {
    CodEmp: newCodEmp,
    CodFil: newCodFil,
    CodCli: newCodCli,
    NumTit: newNumTit,
    CodTpt: newCodTpt,
    VlrAbe: newVlrAbe,
    VlrAba: newVlrAba,
    VctPro: newVctPro,
    VctLim: newVctLim,
    BolAce: newBolAce,
    MsgBol: newMsgBol,
    NomCli: newNomCli,
    TipCli: newTipCli,
    CgcCpf: newCgcCpf,
    EndCli: newEndCli,
    CepCli: newCepCli,
    CidCli: newCidCli,
    BaiCli: newBaiCli,
    SigUfs: newSigUfs,
    FonCli: newFonCli,
    TaxMul: newTaxMul,
    TaxJrs: newTaxJrs,
    ArqJso: newArqJso,
    IdeFin: newIdeFin,
    SitFin: newSitFin,
    IdeCon: newIdeCon,
  };

  const newParametros = Object.entries(parametros)
    .map(([key, value]) => `<${key}>${value}</${key}>\n `)
    .join('');

  let data = `<?xml version="1.0" encoding="utf-8"?>\n<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">\n  
    <soap:Body>\n    
     <${porta}>\n       
        <user>${loginErp}</user>\n      
        <password>${senhaErp}</password>\n        
        <encryption>0</encryption>\n     
        <parameters>\n  
          <dadosGerais>\n 
              ${newParametros}
          </dadosGerais>\n 
        </parameters>\n              
      </${porta}>\n  
    </soap:Body>\n
  </soap:Envelope>\n 
  `;

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${proxyUrl}/${url}`,
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    showToast('error', error);
  }
}

//=-----------------------------------------------------------------------------------=//

export async function CLogin(setLoad) {
  setLoad(true);

  const data = {
    usuario: 'admin',
    senha: 'asd54845',
  };

  return axios
    .post(`${proxyUrl}/${apiUrl}/login`, data, {
      headers: {
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXN1YXJpbyI6ImFkbWluIiwiaWF0IjoxNzQ2NzkwNDIwLCJleHAiOjE3NDY3OTQwMjB9.BUOYs_uelkrxwvzgAolw20qGZ84q3jtcNU9DkETKx1A',
        'Content-Type': 'application/json',
      },
    })
    .then((res) => {
      showToast('success', res.data.message);
      localStorage.setItem('CToken', res.data.token);
      return res.data;
    })
    .catch((error) => {
      showToast('error', error);
    })
    .finally(() => setLoad(false));
}

//=-----------------------------------------------------------------------------------=//

export async function CEmite(
  ideemp,
  idefil,
  idcon,
  numtit,
  vlrabe,
  vlraba,
  vctpro,
  vctlim,
  bolace,
  msgbol,
  nomcli,
  tipcli,
  cgccpf,
  endcli,
  cepcli,
  cidcli,
  baicli,
  sigufs,
  foncli,
  taxmul,
  taxjrs,
  setLoad,
  tentativas = 0
) {
  if (tentativas > 2) {
    showToast('error', 'Falha após várias tentativas.');
    return null;
  }
  const token = localStorage.getItem('CToken');

  const formatDate = (d) => {
    const [day, month, year] = d.split('/');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const date = new Date(formattedDate);

    if (isNaN(date.getTime())) {
      return null;
    }

    return formattedDate;
  };

  let data = JSON.stringify({
    empresaId: ideemp,
    filialId: idefil,
    contaBancariaId: idcon,
    idIntegracao: numtit,
    valorTotal: vlrabe,
    valorAbatimento: vlraba,
    dataVencimento: formatDate(vctpro),
    dataLimitePagamento: formatDate(vctlim),
    boletoAceito: bolace,
    mensagemBoleto: msgbol,
    pagadorNome: nomcli,
    pagadorTipoPessoa: tipcli,
    pagadorCpfCnpj: cgccpf,
    pagadorEndereco: endcli,
    pagadorCep: cepcli,
    pagadorCidade: cidcli,
    pagadorBairro: baicli,
    pagadorUf: sigufs,
    pagadorTelefone: foncli,
    taxaMulta: taxmul,
    taxaJurosMensal: taxjrs,
  });

  try {
    const res = await axios.post(`${proxyUrl}/${apiUrl}/boleto`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    showToast('success', res.data.message);

    //-----\RECURSIVIDADE/-----
    if (res.data?.error?.toLowerCase().includes('token')) {
      console.log('refazer o login');
      await CLogin(setLoad);
      return await CEmite(
        ideemp,
        idefil,
        idcon,
        numtit,
        vlrabe,
        vlraba,
        vctpro,
        vctlim,
        bolace,
        msgbol,
        nomcli,
        tipcli,
        cgccpf,
        endcli,
        cepcli,
        cidcli,
        baicli,
        sigufs,
        foncli,
        taxmul,
        taxjrs,
        setLoad,
        tentativas + 1
      );
    }
    //-----/RECURSIVIDADE\-----
    return res.data;
  } catch (error) {
    //-----\RECURSIVIDADE/-----
    const msg = error.response?.data?.error?.toLowerCase();
    if (msg?.includes('token')) {
      await CLogin(setLoad);
      return await CEmite(
        ideemp,
        idefil,
        idcon,
        numtit,
        vlrabe,
        vlraba,
        vctpro,
        vctlim,
        bolace,
        msgbol,
        nomcli,
        tipcli,
        cgccpf,
        endcli,
        cepcli,
        cidcli,
        baicli,
        sigufs,
        foncli,
        taxmul,
        taxjrs,
        setLoad,
        tentativas + 1
      );
    }
    //-----/RECURSIVIDADE\-----

    showToast('error', error.message || 'Erro desconhecido');
    return null;
  }
}

//=-----------------------------------------------------------------------------------=//

export async function CVisualiza(id, setLoad, tentativas = 0) {
  if (tentativas > 2) {
    showToast('error', 'Falha após várias tentativas.');
    return null;
  }
  const token = localStorage.getItem('CToken');

  try {
    const res = await axios.get(`${proxyUrl}/${apiUrl}/boleto/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const msg = res.data?.message;
    if (msg) showToast('success', msg);

    //-----\RECURSIVIDADE/-----
    if (res.data?.error?.toLowerCase().includes('token')) {
      console.log('refazer o login');
      await CLogin(setLoad);
      return await CVisualiza(id, setLoad, tentativas + 1);
    }
    //-----/RECURSIVIDADE\-----

    return res.data;
  } catch (error) {
    //-----\RECURSIVIDADE/-----
    const msg = error.response?.data?.error?.toLowerCase();
    if (msg?.includes('token')) {
      await CLogin(setLoad);
      return await CVisualiza(id, setLoad, tentativas + 1);
    }
    //-----/RECURSIVIDADE\-----

    showToast('error', error.message || 'Erro desconhecido');
    return null;
  }
}

//=-----------------------------------------------------------------------------------=//

export async function CPdf(id, setLoad, tentativas = 0) {
  if (tentativas > 2) {
    showToast('error', 'Falha após várias tentativas.');
    return null;
  }
  const token = localStorage.getItem('CToken');

  try {
    const res = await axios.get(
      `${proxyUrl}/${apiUrl}/boleto/${id}/pdf?tipo=base64`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    //-----\RECURSIVIDADE/-----
    if (res.data?.error?.toLowerCase().includes('token')) {
      console.log('refazer o login');
      await CLogin(setLoad);
      return await CPdf(id, setLoad, tentativas + 1);
    }
    //-----/RECURSIVIDADE\-----

    return res.data.pdfBase64;
  } catch (error) {
    //-----\RECURSIVIDADE/-----
    const msg = error.response?.data?.error?.toLowerCase();
    if (msg?.includes('token')) {
      console.log('refazer o login');
      await CLogin(setLoad);
      return await CPdf(id, setLoad, tentativas + 1);
    }
    //-----/RECURSIVIDADE\-----

    showToast('error', error.message || 'Erro desconhecido');
    return null;
  }
}
